module.exports = __webpack_public_path__ + "static/img/business_solution_supplychain.410189a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business_solution_supplychain.png
// module id = 6NPE
// module chunks = 1